// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"105":"5e6b6cd9","115":"5e6b6cd9","363":"5e6b6cd9","522":"ee6451e8","950":"5e6b6cd9"}[chunkId] + ".chunk.css";
};